import { Component, OnInit, OnDestroy } from '@angular/core';
import { PatientcodeverificationService } from 'src/app/core/services/patientcodeverification/patientcodeverification.service';
import { timer,interval , Subscription,Observable } from "rxjs";
import { CounterPipe } from 'src/app/modules/Pipes/counter.pipe';
import { map } from 'rxjs/operators'
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-patientcodeverification',
  templateUrl: './patientcodeverification.component.html',
  styleUrls: ['./patientcodeverification.component.scss'],
  providers:[PatientcodeverificationService]
})
export class PatientCodeVerificationComponent implements OnInit {
  QueueId:number = 0; 
  _patCode:string = "";
  get patCode():string
  {
    return this._patCode;
  }
  set patCode(value:string)
  {
   this._patCode = value;
  }
  _pinNum:string = "";
  get pinNum():string
  {
    return this._pinNum;
  }
  set pinNum(value:string)
  {
   this._pinNum = value;
  }
  token :string;
  isCodeVerified:boolean = false;  
  isSms:boolean = true;
  counterDone:boolean = false;
  resendPeriod:number = 60;
  countDown:number ;
  
  tick = 1000;
  _errorMessage:string=''; 
  get errorMessage():string
  {
    return this._errorMessage;
  }
  set errorMessage(value:string)
  {
   this._errorMessage = value;
   this.messageService.add({severity: 'error', summary: 'Error', detail:this._errorMessage, life: 2000});
  }
  constructor(private verificationService : PatientcodeverificationService ,private messageService : MessageService,private router : Router) { }

  ngOnInit(): void {
  }
  verify():void {   
    if(this.patCode == "" || this.patCode == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Please Enter Patient Code", life: 2000});
      //this.alert.warn("Please Enter Patient Code");
      return;
    }
    this.verificationService.verifyPatCode(this.patCode).subscribe(
      {
        next: res => {
          if(res.Success)
          {
            this.counterDone = false; 
            this.patCode = res.Data.PatCode;                        
            this.QueueId = res.Data.QueueId;
            this.resendPeriod = parseInt(res.Data.resendPeriod) *60;
            this.countDown = this.resendPeriod;            
            this.isSms = res.Data.isSms;
            var temp = interval(1000).subscribe(x => {             
              --this.resendPeriod;
              this.countDown = this.resendPeriod;
              if (this.resendPeriod < 0) {
                  this.counterDone = true;
                  temp.unsubscribe();                                    
              }
              else
              {
                this.counterDone = false; 
              }
            });         
            this.isCodeVerified = true;
            //this.alert.success("Sent Successfully");
          }
          else
          {
            this.counterDone = true; 
            this.errorMessage = res.Message;
          }
        },
        error:err => this.errorMessage = "Error While Processing Data"          
      }
    );
  }
  verifyPIN (): void
  {
    if(this.pinNum == "" || this.pinNum == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Please Enter PIN Number", life: 2000});
      //this.alert.warn("Please Enter PIN Number");
      return;
    }
    this.verificationService.verifyPin(this.pinNum,this.patCode,this.QueueId.toString()).subscribe(
      {
        next: res => {
          if(res.Success)
          {
            this.token = res.Data.token;  
            localStorage.clear();
            localStorage.setItem('token',res.Data.token);         
            localStorage.setItem('patientName',res.Data.FullName);
            localStorage.setItem('PatientId',res.Data.PatientId);     
            localStorage.setItem('gender',res.Data.GenderId);          
            localStorage.setItem('Image',res.Data.Image);
            localStorage.setItem('lang',"en");
            if(res.Data.LanguageId == 1){
             localStorage.setItem('lang',"ar");
            }
            window.location.href = 'history';
          }
          else
          {           
            this.errorMessage = res.Message;
          }
        },
        error:err => this.errorMessage = "Error While Processing Data"          
      }
    );
    
  }
  resend (): void
  {
    this.resendPeriod = 60;    
    this.verify();
  }
  ngOnDestroy() {
    this.resendPeriod = 60;
  }   
}
